///<reference path="../../node_modules/angular2/typings/browser.d.ts"/>
"use strict";
require('reflect-metadata');
require('core-js/client/shim');
require('zone.js/dist/zone');
//import 'es6-shim/es6-shim';
//import 'systemjs/dist/system-polyfills';
require('./shims_for_IE');
var platform_browser_dynamic_1 = require('@angular/platform-browser-dynamic');
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var router_deprecated_1 = require('@angular/router-deprecated');
var common_2 = require('@angular/common');
var http_1 = require('@angular/http');
require('rxjs/Rx');
var app_component_1 = require('./app.component');
var clientinfo_service_1 = require('./clientinfo.service');
var DeviceService_1 = require('./services/DeviceService');
platform_browser_dynamic_1.bootstrap(app_component_1.AppComponent, [
    router_deprecated_1.ROUTER_PROVIDERS,
    common_1.CORE_DIRECTIVES,
    http_1.HTTP_PROVIDERS,
    clientinfo_service_1.ClientInfoService,
    DeviceService_1.DeviceService,
    core_1.provide(common_2.LocationStrategy, { useClass: common_2.PathLocationStrategy })
]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/bootstrap.ts
 ** module id = 0
 ** module chunks = 1
 **/